import { render } from "./BaseSequenceBadge.vue?vue&type=template&id=030ade3a&scoped=true"
import script from "./BaseSequenceBadge.vue?vue&type=script&lang=js"
export * from "./BaseSequenceBadge.vue?vue&type=script&lang=js"

import "./BaseSequenceBadge.vue?vue&type=style&index=0&id=030ade3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-030ade3a"]])

export default __exports__